import { ContainerDetails, BookingService } from '@/common/apis/dtos';
import { ContainerTypes } from '@/common/constants/containerTypes';
import { Divider, Typography } from '@chr/eds-react';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import {
  Box,
  Container,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
} from '@mui/material';

interface ContainerSummaryProps {
  services: BookingService[];
}

export const ContainerSummary = (props: ContainerSummaryProps) => {
  const { services } = props;
  const translate = useTranslation();

  const containers = services
    ?.flatMap((s) => s.itemContainers)
    ?.flatMap((c) => c?.containerDetails)
    ?.filter((container): container is ContainerDetails => !!container) ?? [];

  if (containers.length === 0) {
    return null;
  }

  return (
    <Paper elevation={0} variant="outlined">
      <Stack direction="column">
        <Box sx={{ paddingLeft: 2, marginBottom: 1, marginTop: 1 }}>
          <Typography variant="heading300">{translate('Container Summary')}</Typography>
        </Box>
        <Divider emphasis="low" />
        <Container data-testid="container-summary" sx={{paddingLeft: '0px !important'}}>
          <Grid item container wrap="wrap">
            {containers.map((c) => (
              <Grid item key={c.containerType} xs={12} sm={6} md={3}>
                <List component="div">
                  <ListItem>
                    <Typography
                      variant="body100"
                      data-testid={`${c.containerType}`}
                    >
                      {`${translate(
                        ContainerTypes[
                          c.containerType as keyof typeof ContainerTypes
                        ]
                      )}: ${c.containerQuantity}`}
                    </Typography>
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Stack>
    </Paper>
  );
};
